import styles from "./DocsView.module.scss";
import { View, ViewHeader } from "@/components";

export const DocsView = () => {
  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="Documentations"
          description="Access product guides, reference materials, and helpful resources in one place.<br />Use this section to browse documentation and supporting content."
        />
      </div>
    </View>
  );
};
